import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Logo, LotusMark } from "@/components/Logo";
import { CLINIC } from "@/data/clinic";
import { Phone, Mail, Globe } from "lucide-react";

export const PublicLayout = ({ children }) => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-brand-cream grain flex flex-col">
      <header className="sticky top-0 z-50 backdrop-blur-xl bg-brand-cream/85 border-b border-brand-green/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 h-20 flex items-center justify-between">
          <Link to="/" data-testid="header-home-link">
            <Logo />
          </Link>
          <nav className="hidden md:flex items-center gap-9 text-[15px] text-brand-green/80">
            <a href="/#services" className="hover:text-brand-gold transition-colors" data-testid="nav-services">Services</a>
            <a href="/#locations" className="hover:text-brand-gold transition-colors" data-testid="nav-locations">Locations</a>
            <a href="/#about" className="hover:text-brand-gold transition-colors" data-testid="nav-about">About</a>
          </nav>
          <button
            data-testid="header-book-button"
            onClick={() => navigate("/book")}
            className="bg-brand-green text-white rounded-full px-6 py-2.5 text-sm font-medium hover:bg-brand-greenDark transition-all"
          >
            Book Appointment
          </button>
        </div>
      </header>

      <main className="flex-1">{children}</main>

      <footer className="bg-brand-greenDark text-brand-cream mt-24">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 grid md:grid-cols-3 gap-10">
          <div>
            <Logo light />
            <p className="mt-4 text-sm text-brand-cream/70 max-w-xs italic font-script text-base">
              {CLINIC.motto}
            </p>
          </div>
          <div className="text-sm space-y-3 min-w-0">
            <h4 className="font-serif text-brand-gold text-lg mb-3">Get in touch</h4>
            <p className="flex items-start gap-3"><Phone size={16} className="text-brand-gold shrink-0 mt-0.5" /> <span className="break-words">{CLINIC.phone}</span></p>
            <a href={`mailto:${CLINIC.email}`} className="flex items-start gap-3 hover:text-brand-gold transition-colors"><Mail size={16} className="text-brand-gold shrink-0 mt-0.5" /> <span className="break-all">{CLINIC.email}</span></a>
            <p className="flex items-start gap-3"><Globe size={16} className="text-brand-gold shrink-0 mt-0.5" /> <span className="break-all">{CLINIC.website}</span></p>
          </div>
          <div className="text-sm">
            <h4 className="font-serif text-brand-gold text-lg mb-3">Practitioner</h4>
            <p className="font-medium">{CLINIC.practitioner}</p>
            <p className="text-brand-cream/70">{CLINIC.credentials}</p>
            <div className="mt-3 text-brand-cream/70 space-y-1">
              {CLINIC.roles.map((r) => <p key={r}>{r}</p>)}
            </div>
          </div>
        </div>
        <div className="border-t border-brand-cream/15">
          <div className="max-w-7xl mx-auto px-5 sm:px-8 py-5 flex items-center justify-between text-xs text-brand-cream/60">
            <span className="flex items-center gap-2"><LotusMark size={22} /> © {new Date().getFullYear()} {CLINIC.name}</span>
            <Link to="/admin" className="hover:text-brand-gold transition-colors" data-testid="footer-admin-link">Admin</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};
